<!-- This File shows the account details for a Seller -->
<template>
  <div class="">

       <!-- Subscription Type -->
      <br />
      <v-card>
       <v-card-title primary-title>
           <div v-if="cancelAtPeriodEnd">
             Your <b>{{planName}}</b> account will be closed at the end of this period.
           </div>
           <div v-else>
             You are currently on the <b>{{planName}}</b> plan.
             You can close your account and it will deactivate at the end
             of the current period.
           </div>

       </v-card-title>

       <v-card-actions color="accent">
         <v-spacer></v-spacer>
         <div v-if="subscriptionInProgress">
           Working...
           <v-progress-circular
           indeterminate
           color="primary"
           ></v-progress-circular>
         </div>
         <div v-else-if="!cancelAtPeriodEnd">
            <!-- <v-btn @click="cancelSubscriptionNow" flat color="accent">
             Close Account
            </v-btn> -->
            <v-btn @click="cancelSubscriptionBeforePayment" flat color="accent">
              Close Account
             </v-btn>
         </div>

       </v-card-actions>
       <v-layout row class="error--text" v-if="subscriptionErrMessage">
         <v-spacer></v-spacer>
         <span>Error: {{ subscriptionErrMessage }}</span>
         <v-spacer></v-spacer>
       </v-layout>
       <v-layout row class="heading success--text " v-if="cancelSuccess">
         <v-spacer></v-spacer>
         <span>Your susbscription has been canceled.</span>
         <v-spacer></v-spacer>
       </v-layout>
       <v-layout row class="heading success--text " v-if="cancelLaterSuccess && !cancelAtPeriodEnd">
         <v-spacer></v-spacer>
         <span>Your close account request is processing. This page will update when complete.</span>
         <v-spacer></v-spacer>
       </v-layout>

      </v-card>

</div>

</template>

<script>

import {mapState} from 'vuex'
import config from '../../../config.js'

export default {
  name: 'SubscriptionCard',
  components: {
  },
  computed: {
    ...mapState({
      name: state => state.admin.userInfo.name,
      // subscriptionID: state => state.admin.data_ro.subscriptionID,
      planName: state => state.admin.data_ro.planName,
      cancelAtPeriodEnd: state => state.admin.data_ro.cancel_at_period_end,
      locked: state => state.admin.public_settings.locked
    })

  },
  props: {

  },
  data () {
    return {
      subscriptionErrMessage: null,
      subscriptionInProgress: false,
      cancelSuccess: false,
      cancelLaterSuccess: false
    }
  },

  methods: {

    cancelSubscriptionNow: async function () {
      this.subscriptionErrMessage = null
      if (this.locked) {
        this.subscriptionErrMessage = "Account is locked. You cannot make changes"
        return
      }
      this.$confirm(`Are you sure you want to cancel now?`).then(async res => {
        if (res) {
          // Cancel the subscription now
          this.subscriptionInProgress = true

          // Call the async function to cancel
          try {
            const cancelSubscriptionNow = config.getFunctions().httpsCallable('cancelSubscriptionNow')
            await cancelSubscriptionNow()
            this.cancelSuccess = true
          } catch (err) {
            console.error('ERROR cancelling: ' + JSON.stringify(err))
            this.subscriptionErrMessage = err.message
          }

          this.subscriptionInProgress = false
        }
      })
    },
    cancelSubscriptionBeforePayment: async function () {
      this.subscriptionErrMessage = null

      if (this.locked) {
        this.subscriptionErrMessage = "Account is locked. You cannot make changes"
        return
      }
      this.$confirm(`Are you sure you want to close your account?`).then(async res => {
        if (res) {
          // Cancel the subscription now
          this.subscriptionInProgress = true

          // Call the async function to cancel
          try {
            const cancelSubscriptionBeforePayment = config.getFunctions().httpsCallable('cancelSubscriptionBeforePayment')
            await cancelSubscriptionBeforePayment()
            this.cancelLaterSuccess = true
          } catch (err) {
            console.error('ERROR cancelling: ' + JSON.stringify(err))
            this.subscriptionErrMessage = err.message
          }

          this.subscriptionInProgress = false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
